'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-image: url("', '");\n  background-position: center;\n  background-size: cover;\n  overflow: hidden;\n  width: 100%;\n\n  @media (min-width: ', ') {\n    min-height: ', ';\n    padding: ', ';\n  }\n'], ['\n  background-image: url("', '");\n  background-position: center;\n  background-size: cover;\n  overflow: hidden;\n  width: 100%;\n\n  @media (min-width: ', ') {\n    min-height: ', ';\n    padding: ', ';\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HEIGHT_MAP = {
  1: '140px',
  2: '300px',
  3: '300px',
  4: '430px',
  5: '560px',
  6: '600px',
  7: '820px'
};

var PADDING_MAP = {
  1: '105px 0 0',
  2: '140px 0 45px',
  3: '140px 0 100px',
  4: '140px 0 180px',
  5: '140px 0 130px',
  6: '140px 0 180px',
  7: '140px 0 560px'
};

var HeroContainer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.$backgroundImage;
}, _config.breakpoints.m, function (props) {
  return HEIGHT_MAP[props.height] || 'auto';
}, function (props) {
  return PADDING_MAP[props.height] || 0;
});

HeroContainer.displayName = 'HeroContainer';

exports.default = HeroContainer;